import style from "./policy.module.css";
import { SiteFooter, SiteHeader } from "../components/SiteChrome";
import PrivacyPolicyContent from "./PrivacyPolicyContent";

function Policy() {
  return (
    <main className={style.policyPage}>
      <SiteHeader />

      <header className={style.policyHero}>
        <p>Legal</p>
        <h1>TRILLOAN PRIVACY POLICY</h1>
      </header>

      <PrivacyPolicyContent />
      <SiteFooter />
    </main>
  );
}

export default Policy;
